module.exports = __webpack_public_path__ + "img/tel.2ad5e1a7.png";